import React, { useRef, useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { SelectContainer } from './styles';

const CustomSelectComponents = {
    MultiValue: () => null,
    ValueContainer: ({ children, ...props }) => {
        const selectedCount = props.getValue().length;
        const totalOptions = props.options.length;

        let label = children;
        if (selectedCount > 0) {
            label = selectedCount === totalOptions
                ? "Todos selecionados"
                : `${selectedCount} selecionado(s)`;
        }

        return (
            <components.ValueContainer {...props}>
                {label}
            </components.ValueContainer>
        );
    },

    MenuList: (props) => {
        const { options, getValue, selectProps } = props;
        const { onChange } = selectProps;
        const selected = getValue() || [];
        const isAllSelected = options.length > 0 && selected.length === options.length;

        const toggleAll = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (onChange) {
                if (isAllSelected) {
                    onChange([], { action: 'deselect-option' });
                } else {
                    onChange(options, { action: 'select-option' });
                }
            }
        };

        return (
            <components.MenuList {...props}>
                <div className="select-all-header" onClick={toggleAll}>
                    <input type="checkbox" checked={isAllSelected} readOnly />
                    <span>{isAllSelected ? 'Desmarcar Todos' : 'Selecionar Todos'}</span>
                </div>
                {props.children}
            </components.MenuList>
        );
    },

    Option: (props) => (
        <components.Option {...props}>
            <input type="checkbox" checked={props.isSelected} readOnly />
            <label>{props.label}</label>
        </components.Option>
    ),
};

const SelectMulti = ({ label, options = [], value = [], onChange, placeholder, ...rest }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setMenuIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleChange = (newValue, actionMeta) => {
        onChange(newValue, actionMeta);
        // Mantém o menu aberto após selecionar
        setTimeout(() => {
            setMenuIsOpen(true);
        }, 0);
    };

    return (
        <SelectContainer ref={containerRef}>
            <Select
                isMulti
                options={options}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                components={CustomSelectComponents}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix="react-select"
                isSearchable={true}
                menuIsOpen={menuIsOpen}
                onMenuOpen={() => setMenuIsOpen(true)}
                onMenuClose={() => setMenuIsOpen(false)}
                {...rest}
            />
        </SelectContainer>
    );
};

export default SelectMulti;